import {BoardRowHeader} from '@github-ui/board/frames'
import type {BoardRow} from '@github-ui/board-core'

import {axisHeadingText, axisLeadingVisual} from './axis-heading'
import type {BoardAxisLabels} from './board-payload'

/**
 * A swimlane heading for an issues board, drawn from the swimlane field exactly as
 * `BoardColumnHeading` is drawn from the grouping field.
 *
 * The two axes are one contract asked twice: a field that can group a board can swimlane it,
 * and the payload describes a row bucket in the same words as a column bucket. A swimlane
 * that drew less than its column would state the same field two ways on one board.
 *
 * Rendered only on a swimlaned board. The single row an unswimlaned board carries is the
 * board's own rather than a bucket of a field, and it has no heading for a reader to see.
 */
export function BoardRowHeading({row, labels}: {row: BoardRow; labels: BoardAxisLabels}) {
  const label = labels.get(row.key)

  return (
    <BoardRowHeader row={row} {...axisLeadingVisual(label)}>
      {axisHeadingText(label)}
    </BoardRowHeader>
  )
}
